module.exports = "images/android-icon-192x192.bd76b39402040eda2edc01b3982957d2.png";